<template lang="pug">
div
  ods-sub-header(:is-absolute='false' :stretch='false').actionsCupons
    div.actionsLeft
      ods-select(v-model="dropText" @change="onDropDownClick")
        ods-option(
          v-for="item in optionsMenu"
          :key="item.value"
          :label="item.label"
          :value="item.value")
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoyaltyDropDown',
  data: () => {
    return {
      optionsMenu: [],
      dropText: null,
      dropDescr: null,
      config: ''
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getDropMenuState',
      loadingOptionMenu: 'getLoadingOptionMenu',
      getCadena: 'getlistCommercialData'
    })
  },
  methods: {
    ...mapActions(['getListPrograms', 'updateDropDown', 'getConfig']),
    onDropDownClick (event) {
      sessionStorage.setItem('appProgram', event)
      for (let step = 0; step <= this.optionsMenu.length - 1; step++) {
        if (this.optionsMenu[step].value === sessionStorage.getItem('appProgram')) {
          sessionStorage.setItem('appProgramDescr', this.optionsMenu[step].label)
        }
      }
      this.updateDropDown(event)
    },
    convertSelectioData (data) {
      const filteredData = Object.values(data.reduce((acc, cur) => Object.assign(acc, { [cur.codprogr]: cur }), {}))
      const options = []
      for (const i in filteredData) {
        options.push({
          label: filteredData[i].desccpro,
          value: filteredData[i].codprogr
        })
      }
      return options
    },
    getParamsRole () {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      this.role = storageAppData.customer_role
      const params = {
        holding: '',
        codcadena: '',
        codcom: ''
      }
      if (this.role === '01') {
        const holding = this.$store.getters.getListHoldingData
        params.holding = holding ? holding[0].holding : null
      }
      if (this.role === '02') {
        const codcadena = this.getCadena
        params.codcadena = codcadena[0].codcadenal
      }
      if (this.role === '03') {
        const codcadena = this.$store.getters.getlistCommercialData
        params.codcom = codcadena[0].codcom
      }
      sessionStorage.setItem('customerRole', JSON.stringify(params))
      return params
    },
    async getData (data) {
      if (sessionStorage.getItem('appProgram') === null || sessionStorage.getItem('listProgram') === null) {
        const response = await this.getListPrograms(data)
        if (response.registros) {
          response.registros = Array.isArray(response.registros) ? response.registros : [response.registros]
          this.optionsMenu = this.convertSelectioData(response.registros)
          sessionStorage.setItem('listProgram', JSON.stringify(this.optionsMenu))
          this.dropText = this.optionsMenu[0].value
          this.dropDescr = this.optionsMenu[0].label
          this.updateDropDown(this.dropText)
          sessionStorage.setItem('appProgram', this.dropText)
          sessionStorage.setItem('appProgramDescr', this.dropDescr)
        }
      } else {
        this.$store.commit('LOADING_DROP_MENU_FINISHED', true)
        const getProgram = sessionStorage.getItem('appProgram')
        const getListProgram = JSON.parse(sessionStorage.getItem('listProgram'))
        this.dropText = getProgram
        this.optionsMenu = getListProgram
      }
    }
  },
  watch: {
    async loadingOptionMenu (data, oldData) {
      const params = JSON.parse(sessionStorage.getItem('customerRole')) === null ? this.getParamsRole() : JSON.parse(sessionStorage.getItem('customerRole'))
      if (!data) {
        this.getData(params)
      }
    }
  },
  async mounted () {
    const params = JSON.parse(sessionStorage.getItem('customerRole')) === null ? this.getParamsRole() : JSON.parse(sessionStorage.getItem('customerRole'))
    if (!this.loadingOptionMenu) {
      this.getData(params)
    }
  }
}
</script>

<style lang="scss">
</style>
